import React, { useMemo } from "react";
import { BaseEdge, useStore } from "@xyflow/react";
import {
  getFlowEdgeMarkerEnd,
  getFlowEdgePath,
  getFlowEdgeStyle,
  getFlowMarkerUrl,
} from "./flowEdgeStyle";

/** Preview line while dragging a new connection (smooth stub + arrow at cursor). */
export function FlowConnectionLine({
  fromX,
  fromY,
  toX,
  toY,
  fromPosition,
  toPosition,
}) {
  const rfId = useStore((s) => s.rfId);
  const markerEnd = useMemo(
    () => getFlowMarkerUrl(getFlowEdgeMarkerEnd(false), rfId),
    [rfId]
  );

  const [path] = getFlowEdgePath({
    sourceX: fromX,
    sourceY: fromY,
    targetX: toX,
    targetY: toY,
    sourcePosition: fromPosition,
    targetPosition: toPosition,
  });

  return (
    <BaseEdge
      path={path}
      markerEnd={markerEnd}
      style={getFlowEdgeStyle(true)}
    />
  );
}
